@if(imagesAreUploading) { <div class="loading-overlay"></div>}
<div class="admin-theme crop-image-preview">
    <div class="card-title-container">
        <h3 class="admin-subsubheader">Bildupload</h3>
        <p class="admin-text">{{ originalImage ? 'Um deine Website für verschiedene Bildschirmgrößen zu optimieren, kannst du hier das Bild auf verschiedene Formate zuschneiden.' : 'Lade ein neues Bild hoch, damit dieses hier angezeigt werden kann.'}}</p>
    </div>
    @if(!originalImage) {
            <div class="image-config-container">
                <div class="choose-image-container">
                    <button mat-raised-button color="primary" (click)="fileInput.click()">Bild ändern</button>
                </div>
                <input id="file-upload" type="file" accept="image/*" (change)="onFileSelected($event)" style="display: none;" #fileInput />
                @if(errorMessage){ <mat-error class="error">{{ errorMessage }}</mat-error> }
            </div>
    } @else { 
        <div class="crop-controls">
            <mat-button-toggle-group 
                [(ngModel)]="selectedFormat" 
                [hideSingleSelectionIndicator]="true">
                    @for(format of requestedFormats; track $index) {
                        <mat-button-toggle [value]="format"> @if(isFormatUploaded(format)) {<mat-icon>check</mat-icon>} {{format.replace('_', 'x')}} </mat-button-toggle>
                    }
            </mat-button-toggle-group>

            <div class="image-croppper-container">
                @if(onlyFreeFormat()) { 
                    <image-cropper 
                        [alignImage]="'center'"
                        [imageChangedEvent]="originalImage"
                        [maintainAspectRatio]="false"   
                        (imageCropped)="onImageCropped($event)" 
                        (cropperChange)="onCropperChanged($event)"
                        (cropperReady)="onCropperReady()"
                        (imageLoaded)="imageLoaded()" 
                        (loadImageFailed)="loadImageFailed()">
                    </image-cropper>                
                } @else {
                    <image-cropper 
                        [alignImage]="'center'"
                        [imageChangedEvent]="originalImage"
                        [aspectRatio]="cropperState().aspectRatio"
                        [cropper]="cropperState().position"                    
                        (imageCropped)="onImageCropped($event)" 
                        (cropperChange)="onCropperChanged($event)"
                        (cropperReady)="onCropperReady()"
                        (imageLoaded)="imageLoaded()" 
                        (loadImageFailed)="loadImageFailed()">
                    </image-cropper>
                }
                @if(imagesAreUploading) { 
                    <div class="uploading-indicator">
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        <span class="mat-label-medium">Bilder werden hochgeladen...</span>
                </div>
                }
                <form class="example-form">
                    <mat-form-field appearance="outline">
                        <mat-label>Bildbeschreibung</mat-label>
                        <input matInput type="text" placeholder="Bitte füge eine Bildbeschreibung hinzu." [value]="imageAltText$()" (input)="updateAltText($event)" />
                    </mat-form-field>
                </form>
                @if(imageIsLoading || cropperIsLoading) { <mat-spinner></mat-spinner> }
            </div>

            <div class="action-buttons">
                <button mat-flat-button class="warn-button" (click)="closeCrop()">Abbrechen</button>
                <div class="action-buttons-save">
                    <button mat-raised-button color="primary" (click)="confirmCrop()">Bestätigen</button>
                    <button mat-flat-button class="secondary-button" (click)="confirmAllFormats()"
                        [disabled]="!allFormatsUploaded()">
                        Speichern
                    </button>
                </div>
            </div>
        </div>
    }
</div>